import { createContext, useContext } from 'react';

import { IControlsContext } from './types';


export const ControlsContext = createContext({} as IControlsContext);

export const useControlsContext = (): IControlsContext => useContext(ControlsContext);
